import http from "../utils/http";
import notify from "../utils/notifications";
import { store } from "../store";
import { removeLoader, setLoader } from "../redux/actions/loader";

export const getSupervisors = async () => {
    try {
        const res = await http.get(`/users/supervisors`);
        return res.data;
    } catch (err) {
        notify.error(err, "Error al obtener los supervisores");
        return [];
    }
}

export const searchUsers = async (query) => {
    try {
        const res = await http.get(`/users/search?q=${query}`);
        return res.data;
    } catch (err) {
        notify.error(err, "Error al obtener los usuarios");
        return [];
    }
}

export const getActiveUsers = async () => {
    try {
        const res = await http.get(`/users/active`);
        return res.data;
    } catch (err) {
        notify.error(err, "Error al obtener los usuarios");
        return [];
    }
}


export const getOfficesERP = async () => {
    try {
        const res = await http.get(`/users/registerErp`);
        return res.data;
    } catch (err) {
        notify.error(err, "Error al obtener las oficinas del ERP");
        return [];
    }
}

export const registerUserErp = async (datos) => {
    const body = datos;
    try {
        store.dispatch(setLoader("Creando usuario"));
        const res = await http.post(`/users/registerErp`, body);
        notify.success("Usuario creado correctamente.");
        // Backend now returns {id: <number>} instead of [<number>]
        return res.data.id || res.data;
    }
    catch (err) {
        const mensaje = err.response?.data?.error || "Error al crear usuario en el ERP";
    notify.error(mensaje);
        throw err;
    } finally {
        store.dispatch(removeLoader());
    }

};


/**
 * Borrado duro en ERP (unlink) o archivado si unlink falla en el servidor.
 * Idempotente: 204/404 se consideran éxito.
 */
export const deleteUserErp = async (erpUserId) => {
    if (erpUserId === null || erpUserId === undefined || erpUserId === "")
        throw new Error("erpUserId requerido");
    try {
        await http.delete(`/users/deleteErp/${erpUserId}`);
        return true;
    } catch (err) {
        const mensaje = err.response?.data?.error || "Error al eliminar usuario";
    notify.error(mensaje);
    } finally {
        store.dispatch(removeLoader());
    }

};
